import {
  ADD_NEW_ALERT,
  FETCH_ALERTS,
  REMOVE_ALERT_BY_ID,
  FETCH_ALL_ALERTS,
  GLOBAL_ALERT_UPDATE_STATUS,
  FETCH_ALERT_TO_EDIT
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_ALERT:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_ALERTS:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_ALL_ALERTS:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_ALERT_TO_EDIT:
      return {
        ...state,
        ...action.payload
      }
    case REMOVE_ALERT_BY_ID:
      return {
        ...state,
        ...action.payload
      }
    case GLOBAL_ALERT_UPDATE_STATUS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
